export default "/images/vendor/flag-icon-css/flags/4x3/lu.svg?c155a6845ad167cdad8cb83da95b9d10";